import axios from "axios";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { format } from "date-fns";

const LeadStatusModal = ({
  showStatusModal,
  closeStatusModal,
  // updateStatusToContacted,
  updateStatusToQualified,
  selectedLeadId,
  selectedLead,
  // updateLeadStatus
}) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

  console.log("selectedLead in status modal:", selectedLead);
  const updateLeadStatus = (dataForAPI) => {
    let arrayWeHaveToGiveToAPI = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "EDIT",
        lead_id: dataForAPI.lead_id,
        lead_entryTime: dataForAPI.lead_entryTime,
        lead_creatorid: dataForAPI.lead_creatorid,
        lead_coordinator: dataForAPI.lead_coordinator,
        lead_salesperson: dataForAPI.lead_salesperson,
        lead_teamid: dataForAPI.lead_teamid,
        lead_CampaignId: dataForAPI.lead_CampaignId,
        lead_account: dataForAPI.lead_account,
        lead_organization: dataForAPI.lead_organization,
        lead_notes: dataForAPI.lead_notes,
        lead_country: dataForAPI.lead_country,
        lead_city: dataForAPI.lead_city,
        lead_territory: dataForAPI.lead_territory,
        lead_area: dataForAPI.lead_area,
        lead_streetaddress: dataForAPI.lead_streetaddress,
        lead_location: dataForAPI.lead_location,
        lead_appartment: dataForAPI.lead_appartment,
        lead_primarycontact: dataForAPI.lead_primarycontact,
        lead_primarycontacttitle: dataForAPI.lead_primarycontacttitle,
        lead_phone: dataForAPI.lead_phone,
        lead_isphonewhatsapp: dataForAPI.lead_isphonewhatsapp,
        lead_alt_phone: dataForAPI.lead_alt_phone,
        lead_alt_isphonewhatsapp: dataForAPI.lead_alt_isphonewhatsapp,
        lead_email: dataForAPI.lead_email,
        lead_stage: "",
        lead_probability: Number(dataForAPI.lead_probability),
        lead_priority: dataForAPI.lead_priority,
        lead_priority: dataForAPI.lead_priority,
        lead_source: dataForAPI.lead_source,
        lead_status: dataForAPI.lead_status,
        lead_assignedto: dataForAPI.lead_assignedto,
        lead_bookedamount: Number(dataForAPI.lead_bookedamount),
        lead_currencycode: dataForAPI.lead_currencycode,
        lead_currencyrate: "1",
        deptno: "HO",
        prod_code: "",
        prod_Description: "",
        prod_Unit: "",
        prod_Qty: 0,
        prod_Price: 0,
        prod_Amount: 0,
        prod_Comments: "",
        prod_imagepath: "",
      },
    ];
    const jsonToSend = JSON.stringify(arrayWeHaveToGiveToAPI);
    console.log("arrayWeHaveToGiveToAPI:", arrayWeHaveToGiveToAPI);
    console.log("jsonToSend:", jsonToSend);

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatusUpdate/${company_code_from_local_storage}/LEADSTATUS/${dataForAPI.lead_id}/${dataForAPI.lead_status}`;

    axios
      .get(apiUrl, jsonToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("res is ", dataForAPI);
        console.log("success lead status change");

        closeStatusModal();
        window.location.reload();
        // setOpenDialogBox(true);

        // if (res.data.result == "Saved") {
        //   setMessageForUser({
        //     result: "success",
        //     title: "Success",
        //     message: "Successfully Saved",
        //   });
        // } else {
        //   setMessageForUser({
        //     result: "failure",
        //     title: "Error",
        //     message: "Could not save, something went wrong",
        //   });
        //   console.log("failure");
        // }
      })
      .catch((err) => {
        console.log("error while posting lead", err.response.data);
      });
  };

  if (!showStatusModal) return null;
  console.log("selectedLeadId:", selectedLeadId);

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 ">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80 ">
        <div className="flex justify-between items-center">
          <h3 className="text-xl   mb-4 text-center">Update Lead Status</h3>
          <div
            onClick={closeStatusModal}
            className="cursor-pointer text-gray-600 hover:text-gray-900"
          >
            <AiOutlineClose />
          </div>
        </div>

        <div className="flex flex-col gap-1 justify-center">
          <button
            // onClick={() => updateLeadStatus(selectedLeadId, "newLead")}
            onClick={() =>
              updateLeadStatus({ ...selectedLead, lead_status: "newLead" })
            }
            className="bg-orange-400 text-white px-1 py-2 rounded"
          >
            New Lead
          </button>
          <button
            onClick={() =>
              updateLeadStatus({ ...selectedLead, lead_status: "contacted" })
            }
            // onClick={() => updateStatusToContacted(selectedLeadId)}
            className="bg-blue-600 text-white px-1 py-2 rounded"
          >
            Contacted
          </button>
          <button
            onClick={() =>
              updateLeadStatus({
                ...selectedLead,
                lead_status: "attemptedToContact",
              })
            }
            className="bg-red-400 text-white px-1 py-2 rounded"
          >
            Attempted to Contact
          </button>
          <button
            // onClick={() => updateStatusToQualified(selectedLead)} // Pass the selectedLead.id
            onClick={() =>
              updateLeadStatus({ ...selectedLead, lead_status: "qualified" })
            }
            className="bg-green-400 text-white px-1 py-2  rounded"
          >
            Qualified
          </button>
          <button
            onClick={() =>
              updateLeadStatus({ ...selectedLead, lead_status: "unQualified" })
            }
            className="bg-red-600 text-white px-1 py-2 rounded"
          >
            Unqualified
          </button>
          {/* <hr className="mt-4 border-gray-400" />
          <button className="bg-none text-black px-4 py-1 rounded">
            Edit Labels
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default LeadStatusModal;
